import { render } from "./CustomerList.vue?vue&type=template&id=305103b0&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"

import "./CustomerList.vue?vue&type=style&index=0&id=305103b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-305103b0"

export default script